export default "__VITE_ASSET__CKt$gnaH__"